import { engineComponent } from "neo-common";
import { Controller } from "../Controller";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { RouletteView } from "./RouletteView";
import { RouletteModel } from "./RouletteModel";
import { Bet } from "../Bet";

@engineComponent(ComponentTypes.Controller)
export class RouletteController extends Controller {
    public static readonly SpinReceived: string = "eventSpinReceived";
    public static readonly RespinReceived: string = "eventRespinReceived";
    public static readonly WheelStopped: string = "eventWheelStopped";
    public static readonly WinCalculationFinished: string = "eventWinCalculationFinished";
    public static readonly AllWinsFinished: string = "eventAllWinsFinished";
    public static readonly OutroFinished: string = "eventOutroFinished";

    protected _view: RouletteView;
    protected _model: RouletteModel;

    startInitialization(view: any): void {
        if (DEBUG) {
            this.log("startInitialization");
        }

        if (view instanceof RouletteView) {
            this._view = view;
        } else {
            if (DEBUG) {
                this.log("ERROR view is not instance of BaseView");
            }
        }

        this._model = new RouletteModel(this);
    }

    disableLogo(): void {
        this._view.disableLogo();
    }

    initReceived(): void {
        this._view.initReceived(this);
    }

    initIntro(): void {
        this._view.initIntro();
    }

    collect(): void {
        this._view.collect();
    }

    schemasToggle(): void {
        this._view.schemasToggle();
    }

    placeGridBet(roulletBet: Bet): void {
        this._view.placeGridBet(roulletBet);
    }

    resetBets(): void {
        this._view.resetBets();
    }

    placeSchemaBet(roulletBet: Bet): void {
        this._view.placeSchemaBet(roulletBet);
    }

    resetSchemaBets(): void {
        this._view.resetSchemaBets();
    }

    updateSchemaPossibleWins(bets: Array<Bet>): void {
        this._view.updateSchemaPossibleWins(bets);
    }

    changeBet(): void {
        this._view.changeBet();
    }

    spin(): void {
        this._model.spin();
        this._view.spin();
    }

    stop(): void {
        this._view.stop();
    }

    spinReceived(): void {
        this._view.spinReceived();
        this.emit(RouletteController.SpinReceived);
    }

    wheelStopped(): void {
        this.emit(RouletteController.WheelStopped);
    }

    winCalculationFinished(): void {
        this.emit(RouletteController.WinCalculationFinished);
    }

    allWinsFinished(): void {
        this.emit(RouletteController.AllWinsFinished);
    }

    racetrackToggle(enabled: boolean): void {
        this._view.racetrackToggle(enabled);
    }

    autoplayStop(): void {
        this._view.autoplayStop();
    }

    resetWinAnimator(): void {
        this._view.resetWinAnimator();
    }

    intro(): void {
        this._view.intro();
    }

    outro(): void {
        this._view.outro();
    }

    outroFinished(): void {
        this.emit(RouletteController.OutroFinished);
    }

    changeTableColor(color: string): void {
        this._view.changeTableColor(color);
    }

    changeNarratorLanguage(language: string): void {
        this._view.changeNarratorLanguage(language);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Roulette/RouletteController.ts
 **/